import { IconButton, IconButtonProps } from '@mui/material';
import { IconEdit } from '@tabler/icons-react';
import { DS } from './ds';

interface EditButtonProps extends Omit<IconButtonProps, 'children'> {
  iconSize?: number;
}

const EditButton = ({ iconSize = 18, sx, ...rest }: EditButtonProps) => (
  <IconButton
    size="small"
    title="Editar"
    sx={{ color: DS.blue, '&:hover': { bgcolor: '#e0f2ec' }, ...sx }}
    {...rest}
  >
    <IconEdit size={iconSize} />
  </IconButton>
);

export default EditButton;
